import { useEffect, useRef, useState } from "react";
import * as rpc from "../../common/jsonRpcRoutes";
import { notifyBugsnag } from "../bugsnag";

export async function redirectToOldGuestExperience(): Promise<boolean> {
  const oldGuestExperienceUrl = await rpc.call("/old-checkout-url", {});
  if (!oldGuestExperienceUrl) {
    return false;
  }

  try {
    const currentUrl = new URL(window.location.href);
    const oldBase = new URL(oldGuestExperienceUrl);

    if (currentUrl.origin === oldBase.origin) {
      return false;
    }

    window.location.href = `${oldBase.origin}${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
    return true;
  } catch {
    return false;
  }
}

export function shouldRedirectLegacyPreorder(collinsFeatures: unknown): boolean {
  return !!(
    collinsFeatures &&
    typeof collinsFeatures === "object" &&
    !Array.isArray(collinsFeatures) &&
    (collinsFeatures as { redirect_old_preorder_experience?: boolean }).redirect_old_preorder_experience
  );
}

export function useLegacyPreorderRedirect(
  bookingData: { venue: { collins_features?: unknown } } | null,
  bookingId: string,
): boolean {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const hasAttemptedRedirect = useRef(false);

  useEffect(() => {
    if (!bookingData || hasAttemptedRedirect.current) return;

    if (shouldRedirectLegacyPreorder(bookingData.venue.collins_features)) {
      hasAttemptedRedirect.current = true;
      setIsRedirecting(true);
      redirectToOldGuestExperience().catch((error) => {
        notifyBugsnag(new Error("Failed to redirect to old preorder experience"), {
          bookingId,
          timestamp: new Date().toISOString(),
          error,
        });
      });
    }
  }, [bookingData, bookingId]);

  return isRedirecting;
}
